import CategoryIcon from "@mui/icons-material/Category";
import { DormitoryServicePath, ROOM_TYPES } from "utils/constants";
import permissions from "app/permissions";
import ListRoomTypes from "./List";
import CreateRoomType from "./Create";
import EditRoomType from "./Edit";
import ShowRoomType from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <CategoryIcon />,
  name: DormitoryServicePath + ROOM_TYPES,
  title: "Типове стаи",
  list: <ListRoomTypes />,
  create: <CreateRoomType />,
  createPermission: permissions.canManageDormitoryRoomTypes,
  edit: <EditRoomType />,
  editPermission: permissions.canManageDormitoryRoomTypes,
  show: <ShowRoomType />,
  showPermission: permissions.canPreviewDormitoryRoomTypes,
  permission: permissions.canPreviewDormitoryRoomTypes,
};
